import { connect, ResolveThunks } from "react-redux";
import { actions } from "state/slices/userSlice";
import { RootState } from "state/rootReducer";
import { useNavigate } from "react-router";
import { PrivacyContent } from "components/legal/PrivacyContent";

interface StateProps {
  loggedInUserId: string | null;
}

interface DispatchProps {
  onArchiveUser: typeof actions.archiveUser;
}

type Props = StateProps & ResolveThunks<DispatchProps>;

const PrivacyPage = (props: Props): JSX.Element => {
  const navigate = useNavigate();
  return (
    <div className="p-4 md:p-6 text-ink-2 flex flex-col gap-y-2 max-w-prose">
      <PrivacyContent showDeleteAccountBlock="BELOW" />
      {props.loggedInUserId ? (
        <div className="flex">
          <div className="flex flex-shrink button-generic border-danger cursor-pointer">
            <span
              className="text-danger"
              onClick={() =>
                props.onArchiveUser(props.loggedInUserId!, navigate)
              }
            >
              Delete Account
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

function mapState(state: RootState): StateProps {
  return {
    loggedInUserId: state.user.currentUser?.id ?? null,
  };
}

const mapDispatch: DispatchProps = {
  onArchiveUser: actions.archiveUser,
};

export default connect(mapState, mapDispatch)(PrivacyPage);
